import axios from 'axios';

const API_URL = import.meta.env.VITE_APP_API_DOMAIN || 'http://localhost:8080';

axios.defaults.baseURL = API_URL;

const config = {
  API_URL,
  AUTH_CLIENT_ID: import.meta.env.VITE_APP_AUTH_CLIENT_ID || '',
  INDEXED_DB_NAME: 'images',
  INDEXED_DB_VERSION: 1,
  INDEXED_DB_OBJECT_STORE_NAME: 'PdfImages',
} as const;

export { config };
